// extracted by mini-css-extract-plugin
module.exports = {"EditableTagGroup":"editableTagGroup_EditableTagGroup__3_Ed2"};